// extracted by mini-css-extract-plugin
export default {"goodWrap":"goodWrap___ymp2W","right":"right___p7B_V","contentWrap":"contentWrap___DZCdu","content":"content___sYZ4z"};